import { compose, withProps } from 'recompose';
import { withLabel } from '@/se/components/Label';
import NumberInput from '@/se/components/inputs/NumberInput';

export default compose(withLabel('Capacity (patients)'), withProps({ placeholder: 'e.g., 25' }))(NumberInput);
